export default __webpack_public_path__ + "static/media/main.612e490d.png";